import React from "react";

export default function GatewayStepProgress({ current = 1, total = 8, label = "Registration progress" }) {
  return (
    <div className="gatewayStepProgress" role="progressbar" aria-label={label} aria-valuemin="1" aria-valuemax={total} aria-valuenow={current}>
      {Array.from({ length: total }, (_, index) => (
        <span key={index} className={index < current ? "is-active" : ""} aria-hidden="true" />
      ))}
    </div>
  );
}
